import { Route } from "@angular/router";
import { PainelComprasPage } from "./painel-compras.page";

export const PainelComprasRouter: Route[] = [
  { path: 'painel-compras', component: PainelComprasPage }
];
